import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import History from './pages/History';
import BattleDetail from './pages/BattleDetail';
import BattleSettings from './pages/BattleSettings';
import Battle from './pages/Battle';
import BattleResult from './pages/BattleResult';
import AdminRoute from './components/AdminRoute';
import AdminSmsCodes from './pages/AdminSmsCodes';
import PrivateRoute from './components/PrivateRoute';

const AppRoutes = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/admin/sms-codes" element={<AdminRoute><AdminSmsCodes /></AdminRoute>} />
        <Route path="/" element={<Home />} />
        <Route 
          path="/history" 
          element={<History />} 
        />
        <Route 
          path="/battle/:id" 
          element={
            <PrivateRoute>
              <BattleDetail />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/battle-result/:id" 
          element={
            <PrivateRoute>
              <BattleResult />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/battle" 
          element={
            <PrivateRoute>
              <Battle />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/battle-settings" 
          element={
            <AdminRoute>
              <BattleSettings />
            </AdminRoute>
          } 
        />
      </Routes>
    </Layout>
  );
};

export default AppRoutes; 
